import 'react-toastify/dist/ReactToastify.min.css';
import '../stylesheet/perfectScrollbar.global.css';


// WEBPACK FOOTER //
// ./src/interface/theme/inject/index.js